import store from "stores";
import { organizationType } from 'const/nuclias/organization';
import { userType, userPrivilege } from 'const/nuclias/user';
import { cloneDeep, isNil, orderBy, size } from 'lodash';
import orgService from "services/Auth.Organization.service";

import { expandSiteAndTag, initOrgTreeMap } from "ui/Layout/utils"

const orgModalTitle = (modalStatus, modalInfo) => {
  const tmp = {}
  if (modalStatus.org.type === 'create') {
    tmp.title = modalStatus.org.createLabel
    tmp.name = modalInfo.isMSP ? '3819f173a1' : '05cb2cca01'
  } else {
    const editObj = modalStatus.org.editObj
    if (editObj.orgType === organizationType.si) {
      tmp.title = 'c311c07584'
      tmp.name = '3819f173a1'
      tmp.upload = '8c2c941769'
    } else if (editObj.orgType === organizationType.org) {
      tmp.title = '3496e5388a'
      tmp.name = '05cb2cca01'
      tmp.upload = '934020c019'
    } else { // op
      tmp.title = 'bfe009e67f'
      tmp.name = '05cb2cca01'
      tmp.upload = '934020c019'
    }
  }
  return tmp
}

const findMSP = (editObj) => {
  const children = store.getState().pageContext.sp.children;
  const res = children.find(function (item, index) {
    return item.id === editObj.id
  });
  return res
}

const formatData = ({ iconActions, modalData, typeOptions, modalInfo }) => {
  const obj = {
    name: modalData.name.value,
    type: typeOptions[0].value,
    owner: modalData.owner,
    phone: modalData.phone,
    email: modalData.email,
    orgType: modalInfo.isMSP ? organizationType.si : organizationType.org
  }

  const iconObj = {
    action: iconActions.def,
    icon: null
  }

  if (modalInfo.isCreate) {
    obj.serviceProviderCountry = modalData.serviceProviderCountry.iso_code
    if (!isNil(modalData.file)) obj.icon = modalData.file
  } else {
    obj.id = modalData.id
    if (!isNil(modalData.file)) {
      iconObj.icon = modalData.file
      if (isNil(modalData.iconOrigin) || size(modalData.iconOrigin) === 0) {
        iconObj.action = iconActions.new
      } else {
        iconObj.action = iconActions.edit
        obj.iconS3Path = ''
      }
    } else {
      if (!isNil(modalData.iconOrigin) && size(modalData.iconOrigin) > 0 && isNil(modalData.icon))
        iconObj.action = iconActions.del
    }
  }
  return { obj, iconObj }
}

const getOrg = (editObj) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const res = await orgService.getOrgBootstrap(editObj.id)
      Resolve(res.data);
    } catch (error) {
      Reject(error);
    }
  });
}

const changeCheckedMSP = (target, siList) => {
  const copySi = cloneDeep(siList)
  if (isNil(target.isAll)) {
    let checkedAll = true
    for (const item of copySi) {
      if (item.value === target.value) {
        item.checked = !target.checked
        if (!checkedAll) break
      }
      if (!item.checked && !item.isAll) checkedAll = false
    }
    copySi[0].checked = checkedAll
  } else {
    const newChecked = !target.checked
    for (const list of copySi) {
      list.checked = newChecked
    }
  }
  return copySi
}

const getCheckedMSP = (targetInfo, siList) => {
  const result = []
  for (const item of siList) {
    if (isNil(item.isAll)) {
      if (item.checked) result.push({ id: item.value, type: organizationType.si })
    } else if (item.checked) {
      result.push({ id: targetInfo.employerId, type: organizationType.sp })
      break
    }
  }
  return result
}

const genSiList = () => {
  const children = store.getState().pageContext.sp.children;
  let list = children.map(function (item) {
    return {
      title: item.name,
      value: item.id,
      checked: true
    }
  });
  list = orderBy(list, [item => item.title.toLowerCase()], 'asc')
  list.unshift({ title: 'b1c94ca2fb', checked: true, isAll: true });
  return list
}

const getSelectedOrg = (editObj) => {
  return new Promise(async (Resolve, Reject) => {
    try {
      const res = await getOrg(editObj)
      let selectedOrg = await expandSiteAndTag({ selectedOrg: res })
      selectedOrg = await initOrgTreeMap(selectedOrg)
      Resolve(selectedOrg);
    } catch (error) {
      Reject(error);
    }
  });
}

const getDefaultSiteList = (orgObj) => {
  const { selectedOrg } = orgObj

  let tagList = [], siteList = []
  Object.values(selectedOrg.storeTagObj).forEach((item) => {
    tagList.push({
      title: item.name,
      value: item.id,
    })
  });
  tagList = orderBy(tagList, [item => item.title.toLowerCase()], 'asc')
  tagList.unshift({ title: '299287797e', isAll: true, value: null, isActive: true })

  Object.values(selectedOrg.storeObj).forEach((item) => {
    siteList.push({
      title: item.name,
      value: item.id,
    })
  });
  siteList = orderBy(siteList, [item => item.title.toLowerCase()], 'asc')
  siteList.unshift({ title: 'b1c94ca2fb', isAll: true, value: null, isActive: true })
  return { tagList, siteList }
}

const getSiteIds = (target, orgTreeMap) => {
  const idList = []
  for (const [siteId, ids] of Object.entries(orgTreeMap.withStore)) {
    if (ids.indexOf(target.value) !== -1) {
      idList.push(parseInt(siteId))
    }
  }
  return idList
}

const changeCheckedTag = (target, options, modalInfo) => {
  const { orgTreeMap, selectedOrg } = modalInfo
  const siteIds = getSiteIds(target, orgTreeMap)
  const copyList = cloneDeep(options)

  copyList.tagList.map(function (item) {
    item.isActive = item.value === target.value ? true : false
    return item
  });

  let siteList = []
  for (const [key, item] of Object.entries(selectedOrg.storeObj)) {
    if (!isNil(target.value) && siteIds.indexOf(item.id) === -1) continue
    siteList.push({
      title: item.name,
      value: item.id,
    })
  }
  siteList = orderBy(siteList, [item => item.title.toLowerCase()], 'asc')
  siteList.unshift({ title: 'b1c94ca2fb', isAll: true, value: null, isActive: true })
  copyList.siteList = siteList
  const targets = {
    selectedTag: target,
    selectedSite: siteList[0]
  }
  return { targets, copyList }
}

const getCheckedSite = (targetInfo, modalData) => {
  let newType = null
  let resources = []
  if (isNil(modalData.selectedTag?.value) && isNil(modalData.selectedSite?.value)) {
    newType = userType.org
    resources = [{ id: targetInfo.employerId, type: organizationType.org }]
  } else if (!isNil(modalData.selectedSite?.value)) {
    newType = userType.site
    resources = [{ id: modalData.selectedSite.value, type: organizationType.site }]
  } else {
    newType = userType.siteTag
    resources = [{ id: modalData.selectedTag.value, type: organizationType.tag }]
  }
  return { newType, resources }
}

const getAllTagList = (storeTagObj) => {
  let list = []
  Object.values(storeTagObj).forEach((item) => {
    list.push({
      title: item.name,
      value: item.id,
    })
  });
  list = orderBy(list, [item => item.title.toLowerCase()], 'asc')
  list.unshift({ title: '6adf97f83a', isAll: true, value: null, isActive: true })
  return list
}

export default {
  orgModalTitle,
  findMSP,
  formatData,
  getOrg,
  genSiList,
  changeCheckedMSP,
  getCheckedMSP,
  getSelectedOrg,
  getDefaultSiteList,
  changeCheckedTag,
  getCheckedSite,
  getAllTagList
}